module.exports = __webpack_public_path__ + "media/svg/patch-question-fill-f0b845d0.svg";